import React, {Fragment, Suspense} from 'react';

const History = props => {
    return (
        <Fragment>
            <div>
                History Coming Soon...!
            </div>
        </Fragment>
    )
}

export default History;
